import React, { useState } from 'react';
import { supabase } from '../lib/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    const redirectTo = `${window.location.origin}/#/reset-password`;
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      setSent(true);
    }
  }

  return (
    <div style={{ minHeight: '100dvh', background: '#1A1A1A', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      {/* Logo */}
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <div style={{ fontSize: '1.8rem', fontWeight: 400, color: '#fff', letterSpacing: '0.04em' }}>team <span style={{ fontWeight: 800 }}>breakthrough</span></div>
        <div style={{ color: '#FF6200', fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.18em', marginTop: 6 }}>BOX · BATH · CORSHAM</div>
      </div>

      {/* Card */}
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 380 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: 8 }}>Forgot password?</h2>
        <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: 20, lineHeight: 1.5 }}>
          Enter your email and we'll send you a link to reset your password.
        </p>

        {sent ? (
          <div>
            <div style={{ background: '#FFF4ED', border: '1px solid #FF6200', borderRadius: 10, padding: 16, marginBottom: 20 }}>
              <div style={{ fontWeight: 700, marginBottom: 4, color: '#FF6200' }}>✓ Check your inbox</div>
              <div style={{ fontSize: '0.85rem', color: '#444', lineHeight: 1.5 }}>
                We've sent a password reset link to <strong>{email}</strong>. Click the link in the email to set a new password.
              </div>
            </div>
            <p style={{ fontSize: '0.8rem', color: '#888', textAlign: 'center', lineHeight: 1.5 }}>
              Didn't see it? Check your spam folder, or try again in a few minutes.
            </p>
            <a href="/#/login" style={{ display: 'block', textAlign: 'center', marginTop: 16, color: '#FF6200', fontWeight: 600, fontSize: '0.9rem' }}>← Back to login</a>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" autoFocus />
            </div>
            <button className="btn btn-primary btn-full" type="submit" disabled={loading} style={{ marginTop: 8 }}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <p style={{ textAlign: 'center', marginTop: 20, fontSize: '0.85rem' }}>
              <a href="/#/login" style={{ color: '#666', fontWeight: 500 }}>← Back to login</a>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
